import { defineMessages } from '@cookbook/solid-intl'

// Split out of the page's own messages file so the router's document-title
// wiring doesn't pull the whole page into the boot-critical chunk. Same pattern
// as `booking-policies-page-routing.messages.en.js`.
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Completing your Lodgr sign in.',
        id: 'MobileOAuthCallbackPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Signing in | Lodgr',
        id: 'MobileOAuthCallbackPage.titleMessage',
    }),
}
